// extracted by mini-css-extract-plugin
export default {"modal":"tba-z","modalContent":"uba-z","footer":"vba-z","cancelBtn":"wba-z","disabled":"xba-z","formWrapper":"yba-z","fade":"zba-z","fade-in":"Aba-z","iframe":"Bba-z"};